<template>
  <div class="status-step">
    <div class="h-custom-step">
      <div
        class="h-custom-step-item"
        v-for="(stepItem, stepIndex) in stepList"
        :key="stepIndex"
        :style="{ width: 100 / stepList.length + '%', 'flex-shrink': 0 }"
      >
        <div class="f-r-s-c">
          <div
            class="step-circle"
            :class="{
              'step-circle-active': stepIndex <= currentStep,
            }"
          >
            {{ stepIndex + 1 }}
          </div>
          <div
            class="step-line"
            :class="{ 'step-line-active': stepIndex < currentStep }"
          ></div>
        </div>
        <p
          class="step-desc-bold"
          :class="{
            'step-desc-bold-active': stepIndex <= currentStep,
          }"
        >
          {{ stepItem.label }}
        </p>
        <div>
          <p class="step-desc">{{ stepItem.time || '&nbsp;' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zhenyun-custom-step',
  props: {
    stepList: {
      type: Array,
      default: () => [],
    },
    currentStep: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      //
    }
  },
  methods: {
    //
  },
  mounted() {
    //
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.status-step {
  position: relative;
  padding-left: 15px;
}
.status-step::before {
  position: absolute;
  top: 50%;
  left: -10px;
  margin-top: -25px;
  content: '';
  width: 1px;
  height: 49px;
  background: #dcdcdc;
}
.h-custom-step::before {
  content: '';
  display: block;
  width: 1px;
  height: 49px;
  background-color: #dcdcdc;
  position: absolute;
  top: 12px;
  left: -12px;
  z-index: -1;
}
.h-custom-step {
  display: flex;
  align-items: center;
  position: relative;
  .h-custom-step-item {
    .step-circle {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #cecfd2;
      text-align: center;
      line-height: 24px;
      color: #cecfd2;
      font-size: 14px;
      font-weight: 700;
    }
    .step-circle.step-circle-active {
      background: #0863ff;
      line-height: 24px;
      color: #ffffff;
      border-color: #0863ff;
    }
    .step-line {
      flex: 1;
      height: 2px;
      background: #e5e5e5;
      margin-top: 12px;
      height: 1px;
      width: 98px;
      margin: 0 8px;
    }
    .step-line.step-line-active {
      background: #0863ff;
    }
    .step-desc-bold {
      color: #999999;
      font-family: SourceHanSansCN-Regular;
      font-size: 14px;
      line-height: 22px;
      margin-top: 9px;
    }
    .step-desc-bold.step-desc-bold-active {
      color: #333333;
    }
    .step-desc {
      color: #666666;
      font-family: SourceHanSansCN-Regular;
      font-size: 12px;
    }
  }
  .h-custom-step-item:last-child .step-line {
    display: none;
  }
}
.f-r-s-c {
  display: flex;
  align-items: center;
}
</style>
